import { SignupContainer } from "@shared/features/auth/components/Signup/SignupContainer";
import { Invitation } from "@platform/types/platform.types";
import { PanelTitle } from "@shared/ui/PanelTitle";
import { useBreakpoint } from "@shared/hooks/useBreakpoint";

type Props = {
  onSuccess: (data: any) => void;
  invitation: Invitation;
  onError?: () => void;
};

export function OnboardingSignup({ onSuccess, invitation, onError }: Props) {
  const isMdScreen = useBreakpoint("md");

  return (
    <>
      <PanelTitle
        title="Create Your Account"
        description="Great, Pollinator is a good fit for you. Welcome!"
        isInverted={isMdScreen}
      />
      <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
        <SignupContainer
          invitation={invitation}
          onError={onError}
          onSuccess={onSuccess}
        />
      </div>
    </>
  );
}

export default OnboardingSignup;
